import { type BaseItem } from './common.js';

export const ON = 'on' as const;
export const OFF = 'off' as const;

type Option = typeof ON | typeof OFF;

// Used to define type below
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FlagNames = [
  'FingerprintPGAutoExportOnCheckIn',
  'enableCarryForwardProblemGroups',
  'enableFeedFunctions',
  'enableExperimentalOcr',
  'enableFlowBuilderDemoRoutes',
  'enableSelfServeFormMapping',
  'enableBlockMocking',
  'enablePersistTestCases',
  'exampleFlag',
] as const;

export type FlagName = (typeof FlagNames)[number];

export interface BaseSetting {
  userId: string;
  name: FlagName;
  option: Option;
}

export interface Setting extends BaseItem, BaseSetting {}

export type FlagMap = Record<string, string>;

export interface FlagOption {
  default: string;
  description: string;
  options: Record<Option, string>;
}

export type FlagOptions = Record<FlagName, FlagOption>;
